import React, { useEffect, useState } from "react";
import styles from "./ListViewFaculty.module.css";
import TeachingListview from "./TeachingListview";
import NteachingListView from "./NteachingListView";
import PanelMembersLiistview from "./PanelMembersLiistview";
import { useNavigate, useParams } from "react-router-dom";

function ListViewFaculty() {
  const { active_tab } = useParams();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState(1);
  const [tabChanged, setTabChanged] = useState(false);

  useEffect(() => {
    // Update the activeTab state when the component mounts and whenever active_tab changes in the URL
    setActiveTab(Number(active_tab) || 1);
    // setActiveTab(1);
  }, [active_tab]);

  const handleTabClick = (index) => {
    setActiveTab(index);
    setTabChanged(true);
    navigate(`/Faculties/${index}`);
  };

  return (
    <div className={`${styles.cm_container} BathHeader`}>
      {/* <h6 className={`${styles.cm_title} ms-0 me-0`}></h6> */}
      <div className="col-md-6 col-12">
        <h2 className="TitleHeader">Team Members</h2>
      </div>
      <div className="row">
        <div className="col-md-12">
          {/* nav-tabs */}
          <ul
            className="nav cm_nav-fill mb-3"
            id="cm_listViewTabs"
            role="tablist"
          >
            <li className="nav-item" role="presentation">
              <a
                className={activeTab === 1 ? "nav-link active" : "nav-link"}
                // id="ex2-tab-1"
                data-mdb-toggle="tab"
                href="javascript:void(0)"
                role="tab"
                aria-controls="ex2-tabs-1"
                aria-selected={activeTab === 1}
                onClick={() => handleTabClick(1)}
              >
                Faculty
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className={activeTab === 2 ? "nav-link active" : "nav-link"}
                // id="ex2-tab-2"
                data-mdb-toggle="tab"
                href="javascript:void(0)"
                role="tab"
                aria-controls="ex2-tabs-2"
                aria-selected={activeTab === 2}
                onClick={() => handleTabClick(2)}
              >
                Staff
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className={activeTab === 3 ? "nav-link active" : "nav-link"}
                // id="ex2-tab-3"
                data-mdb-toggle="tab"
                href="javascript:void(0)"
                role="tab"
                aria-controls="ex2-tabs-3"
                aria-selected={activeTab === 3}
                onClick={() => handleTabClick(3)}
              >
                Panel Members
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Tab content */}
      {activeTab === 1 && (
        <TeachingListview
          activeTab={activeTab}
          tabChanged={tabChanged}
          setTabChanged={setTabChanged}
        />
      )}
      {activeTab === 2 && (
        <NteachingListView
          activeTab={activeTab}
          tabChanged={tabChanged}
          setTabChanged={setTabChanged}
        />
      )}
      {activeTab === 3 && (
        <PanelMembersLiistview
          activeTab={activeTab}
          tabChanged={tabChanged}
          setTabChanged={setTabChanged}
        />
      )}
    </div>
  );
}

export default ListViewFaculty;
